import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import { FiLink } from "react-icons/fi";
import { shareMenuData } from "../../../datasets/blog/shareMenuData";

export const ShareMenu = ({ isOpen, postData }) => {
  const [copied, changeCopied] = useState(false);
  const [href, setHref] = useState(false);

  useEffect(() => {
    if (copied === true) {
      document.querySelector(".share_menu-copied").classList.add("visible");
      setTimeout(() => {
        changeCopied(false);
        document.querySelector(".share_menu-copied").classList.remove("visible");
      }, 2000);
    }
  }, [copied]);

  useEffect(() => {
    setHref(window.location.href);
  }, []);

  const copyLink = () => {
    changeCopied(true);
    let dummy = document.createElement("input"),
      text = window.location.href;

    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  };

  return (
    <section className={clsx("share_menu-background", isOpen && "hover")}>
      <section className="share_menu-main">
        <TwitterShareButton url={href} title={postData.title} className="share_menu-label">
          <TwitterIcon size={36} round={true} />
          <p>{shareMenuData.twitter}</p>
        </TwitterShareButton>
        <FacebookShareButton url={href} quote={postData.title} className="share_menu-label">
          <FacebookIcon size={36} round={true} />
          <p>{shareMenuData.facebook}</p>
        </FacebookShareButton>
        <LinkedinShareButton
          url={href}
          title={postData.title}
          summary={postData.summary}
          source={"Demyst"}
          className="share_menu-label"
        >
          <LinkedinIcon size={36} round={true} />
          <p>{shareMenuData.linkedin}</p>
        </LinkedinShareButton>
        <button className="share_menu-label" onClick={copyLink}>
          <div className="share_menu-circle">
            <FiLink />
          </div>
          <p>{shareMenuData.copy}</p>
          <section className="share_menu-copied">
            <p>{shareMenuData.copied}</p>
            <div className="share_menu-copied-mask" />
          </section>
        </button>
      </section>
    </section>
  );
};

ShareMenu.propTypes = {
  isOpen: PropTypes.bool,
};
